<template>
  <div
    class="wrapper-up"
    :class="{ 'wrapper-up--enrollment-drawer': enrollmentDrawerOpen }"
  >
    <div class="wrapper">
      <TheHeader
        :show-logo-menu="showLogoMenu"
        @isCloseUserAvatar="isShowOrNotShowUserAvatar"
        :showMenu="showMenu"
        @showMenu="changeShowMenu"
      />
      <TheSidebarOld @showMenu="changeShowMenu" />
      <main
        class="main main--tablet"
        :class="[
          {
            main__sidebar_opened:
              showSidebar && $route.path.split('/')[1] !== 'security'
          },
          { 'main--moved-xl': getDayRecordPanel },
          { mobile: isMobile },
          { 'main--moved': showMenu },
          {
            'main—move-locked':
              showMenu && $route.path.split('/')[1] === 'security'
          }
        ]"
        @click="
          () => {
            isCloseUserAvatar();
            isCloseDropDownList();
          }
        "
      >
        <!--        Content        -->
        <slot />
      </main>

      <TheFooter />
    </div>
    <TheBottomMenu />
    <!-- Temporarily disabled — re-enable by uncommenting -->
    <!-- <PushNotificationsPrompt /> -->
    <TheMobileTabBar />
  </div>
</template>
<script>
import TheHeader from './TheHeader';
import TheSidebarOld from '@/Components/Layout/TheSidebarOld';
import TheFooter from './TheFooter';
import TheBottomMenu from './TheBottomMenu';
// import PushNotificationsPrompt from './PushNotificationsPrompt'; // Temporarily disabled
import TheMobileTabBar from '@/Components/Layout/TheMobileTabBar';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'LayoutDefault',
  components: {
    TheBottomMenu,
    TheFooter,
    TheSidebarOld,
    TheHeader,
    // PushNotificationsPrompt, // Temporarily disabled
    TheMobileTabBar
  },
  data() {
    return {
      showLogoMenu: false,
      showMenu: false,
      // The side menu was closed for the study center enrollment drawer.
      menuClosedForDrawer: false,
      enrollmentDrawerOpen: false
    };
  },
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    ...mapGetters({
      getDayRecordPanel: 'studyCenter/getDayRecordPanel',
      getisDropDownActiveOne: 'managementList/getisDropDownActiveOne',
      getisDropDownActiveTwo: 'managementList/getisDropDownActiveTwo'
    }),
    showSidebar() {
      return this.$store.getters['front/getSidebarStatus'];
    },
    isStudent() {
      return this.$store.getters['auth/user'].entity_id === 2;
    }
  },
  mounted() {
    this.showMenu = localStorage.getItem('showMenu') === 'true' ? true : false;
    this.$root.$on('scv2-drawer', this.onEnrollmentDrawer);
  },
  beforeDestroy() {
    this.$root.$off('scv2-drawer', this.onEnrollmentDrawer);
  },
  methods: {
    parse(type) {
      return typeof type == 'string' ? JSON.parse(type) : type;
    },
    ...mapActions({
      management_list_updated: 'managementList/management_list_updated',
      management_list_updated_isDropDownActiveOne:
        'managementList/management_list_updated_isDropDownActiveOne',
      management_list_updated_isDropDownActiveTwo:
        'managementList/management_list_updated_isDropDownActiveTwo',
      setSidebarStatus: 'front/setSidebarStatus'
    }),
    changeShowMenu(menu) {
      localStorage.setItem('showMenu', menu);

      this.showMenu = menu;
      this.menuClosedForDrawer = false;
    },
    // The drawer and the open menu don't fit side by side: the menu closes
    // while the drawer is open and comes back after. The saved preference
    // (localStorage) is left as is.
    onEnrollmentDrawer(open) {
      this.enrollmentDrawerOpen = open;
      if (open && this.showMenu) {
        this.showMenu = false;
        this.menuClosedForDrawer = true;
      } else if (!open && this.menuClosedForDrawer) {
        this.showMenu = true;
        this.menuClosedForDrawer = false;
      }
    },
    isShowOrNotShowUserAvatar(prop) {
      this.showLogoMenu = prop;
    },
    isCloseUserAvatar() {
      this.showLogoMenu = false;
    },
    isCloseDropDownList() {
      this.management_list_updated_isDropDownActiveOne(false);
      this.management_list_updated_isDropDownActiveTwo(false);
      this.management_list_updated(false);
    }
  }
};
</script>

<style lang="scss">
// The side menu opened next to the study center enrollment drawer
// (z-index 1200) goes over it.
.wrapper-up--enrollment-drawer .menu.active {
  z-index: 1201;
}
// On mobile we have a fixed tab bar (TheMobileTabBar) at the bottom and the
// existing .footer is also `position: fixed; bottom: 0` — so without an
// explicit override the footer hides behind the tab bar. Stack them:
//   footer  → bottom = tab-bar height
//   tab bar → bottom = 0
// and reserve room at the page level so the scrollable content doesn't end
// underneath either of them.
@media (max-width: 760px) {
  // Footer is hidden on mobile — its content lives in /mobile-menu now.
  .footer {
    display: none !important;
  }
  // The header's hamburger button is redundant on mobile — navigation
  // happens via the bottom tab bar. Drop the 56px right reservation that
  // was holding its slot, and slide the QR button into that vacated spot.
  .header__menu-btn {
    display: none !important;
  }
  .header {
    padding-right: 8px !important;
    min-height: 56px;
  }
  .header .qr-code,
  .header .st-qr-fixed.qr-code {
    position: absolute !important;
    top: 0 !important;
    bottom: 0 !important;
    right: 0 !important;
    margin: 0 !important;
    width: 56px !important;
    // Stretch to header height so the button never overflows past the
    // header bottom border.
    height: auto !important;
    border-radius: 0 !important;
  }
  // Mobile-only back button next to the QR — sits just left of the QR slot
  // (RTL: visually to the left of the right-edge QR) and is hidden on desktop.
  .header .header__mob-back {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: absolute !important;
    top: 50%;
    right: 64px; // 56px QR width + 8px gap
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border-radius: 10px;
    border: none;
    background: linear-gradient(135deg, #5aa7ff, #3a86d8);
    color: #fff;
    cursor: pointer;
    box-shadow: 0 4px 10px -4px rgba(64, 159, 255, 0.5);
    transition: filter 0.15s ease, transform 0.12s ease;

    svg,
    img {
      width: 22px;
      height: 22px;
      stroke: #fff;
      fill: #fff;
      color: #fff;
    }
    *[stroke] {
      stroke: #fff;
    }

    &:active {
      transform: translateY(-50%) scale(0.95);
    }
    &:hover {
      filter: brightness(1.05);
    }
  }
  // Reserve room at the bottom for the floating pill tab bar (60px pill +
  // 8px padding top/bottom + safe-area + the FAB that sticks up out of the
  // pill). Without this, the last row of any page is covered by the bar.
  .wrapper-up {
    padding-bottom: calc(110px + env(safe-area-inset-bottom, 0px));
  }
}

// Hide the mobile back button on desktop where there's already a separate
// .header__back-btn rendered.
@media (min-width: 761px) {
  .header .header__mob-back {
    display: none !important;
  }
}
</style>
